const { REACT_APP_LC_LICENSE } = process.env;

/**
 * `LC_LICENSE` — Retrieves `REACT_APP_LC_LICENSE` from .env
 * License for LiveChat widget
 * @constant {string} lclicense
 * @default
 */
export const LC_LICENSE = parseInt(REACT_APP_LC_LICENSE, 10);
